// The "What's New" highlight reel, opened from the ✨ next to the B4W brand and
// from a release card on the Updates page. Content comes from the releases
// registry (src/whatsnew/releases.js); falls back to plain text highlights when
// a published release has no registry entry yet.
import React from 'react';
import { createPortal } from 'react-dom';
import '../styles/WhatsNewModal.css';

export default function WhatsNewModal({ visible, release, onClose }) {
  if (!visible || !release) return null;

  const highlights = Array.isArray(release.highlights) ? release.highlights : [];

  const modal = (
    <div className="whatsnew-backdrop" onClick={onClose}>
      <div
        className="whatsnew-modal"
        role="dialog"
        aria-modal="true"
        aria-label={release.title || "What's New"}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="whatsnew-header">
          <div>
            <div className="whatsnew-eyebrow">✨ What's New</div>
            <h2 className="whatsnew-title">{release.title}</h2>
            {release.date && <div className="whatsnew-date">{release.date}</div>}
          </div>
          <button className="whatsnew-close" type="button" aria-label="Close" onClick={onClose}>
            ×
          </button>
        </div>

        {release.intro && <p className="whatsnew-intro">{release.intro}</p>}

        <div className="whatsnew-body">
          {highlights.map((h, i) => (
            <section className="whatsnew-card" key={i}>
              {h.image && (
                <img className="whatsnew-shot" src={h.image} alt={h.title || ''} loading="lazy" />
              )}
              <div className="whatsnew-card-text">
                {h.title && <h3 className="whatsnew-card-title">{h.title}</h3>}
                {h.body && <p className="whatsnew-card-body">{h.body}</p>}
              </div>
            </section>
          ))}
        </div>

        <button className="whatsnew-done" type="button" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );

  return createPortal(modal, document.body);
}
